import {
  AfterViewInit,
  Component,
  ElementRef,
  EventEmitter,
  Input,
  NgModule,
  OnDestroy,
  Output,
  ViewChild,
} from '@angular/core';
import { BrowserModule } from '@angular/platform-browser';
import {
  DxTreeViewComponent,
  DxTreeViewModule,
} from 'devextreme-angular/ui/tree-view';
import * as events from 'devextreme/events';
import { navbarItems, navbarItemsHlad } from './../../../app-navigation';

@Component({
  selector: 'app-side-navigation-menu',
  templateUrl: './side-navigation-menu.component.html',
  styleUrls: ['./side-navigation-menu.component.scss'],
})
export class SideNavigationMenuComponent implements AfterViewInit, OnDestroy {
  @ViewChild(DxTreeViewComponent, { static: true })
  menu: DxTreeViewComponent;

  @Output()
  selectedItemChanged = new EventEmitter<string>();

  @Output()
  openMenu = new EventEmitter<any>();

  private _selectedItem: String;
  @Input()
  set selectedItem(value: String) {
    this._selectedItem = value;
    if (!this.menu.instance) {
      return;
    }
    this.menu.instance.selectItem(value);
  }

  private _items;
  get items() {
    if (!this._items) {
      if (parseInt(localStorage.getItem('firma')) != 3) {
        this._items = navbarItems.map((item) => ({
          ...item,
          expanded: this._compactMode,
        }));
      } else {
        this._items = navbarItemsHlad.map((item) => ({
          ...item,
          expanded: this._compactMode,
        }));
      }
      // this._items = navigation.map((item) => ({ ...item, expanded: !this._compactMode })); with submenu opened
    }

    return this._items;
  }

  private _compactMode = false;
  @Input()
  get compactMode() {
    return this._compactMode;
  }
  set compactMode(val) {
    this._compactMode = val;

    if (!this.menu.instance) {
      return;
    }

    if (val) {
      this.menu.instance.collapseAll();
    } else {
      this.menu.instance.expandItem(this._selectedItem);
    }
  }

  constructor(private elementRef: ElementRef) {}

  onItemClick(event) {
    //console.log('event: ', event);
    if (event.itemData.path == '/dostavnice') {
      sessionStorage.setItem('iddostavnica', '');
    }
    this.selectedItemChanged.emit(event);
  }

  ngAfterViewInit() {
    events.on(this.elementRef.nativeElement, 'dxclick', (e) => {
      this.openMenu.next(e);
    });
  }

  ngOnDestroy() {
    events.off(this.elementRef.nativeElement, 'dxclick');
  }
}

@NgModule({
  imports: [DxTreeViewModule, BrowserModule],
  declarations: [SideNavigationMenuComponent],
  exports: [SideNavigationMenuComponent],
  bootstrap: [SideNavigationMenuComponent],
})
export class SideNavigationMenuModule {}
